<script>
	module.exports = {
		props: {
			tabVariant: {
				default: 'pill-tabs'
			}
		},
		components: {
			'student-knowledge-inventory-about': require('components/student-knowledge-inventory-about.vue').default,
			'student-knowledge-inventory-results': require('components/student-knowledge-inventory-results.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		modelData: {
			skiTab: 'skiTab',
			classCode: 'classCode',
			roster: 'roster',
			skiAssignments: 'skiAssignments'
		},
		mounted() {
			if (!this.skiTab) {
				this.skiTab = 'about';
			}
		},
		computed: {
			currentRoster() {
				const roster = this.roster;
				const classCode = this.classCode;
				const currentRoster = roster && roster[classCode];

				return currentRoster;
			},
			skiAssignment() {
				const cc = this.classCode;
				const skiAssignments = this.skiAssignments;
				let ski = null;

				if (cc && Array.isArray(skiAssignments)) {
					ski = skiAssignments.find(s => !s.ed);
				}

				return ski;
			},
			skiStarted() {
				const skiAssignment = this.skiAssignment;
				return skiAssignment && skiAssignment.d < Date.now() / 1000;
			},
			hasResults() {
				const skiAssignments = this.skiAssignments;
				return this.skiStarted || (Array.isArray(skiAssignments) && skiAssignments.length > 0);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.student-knowledge-inventory {
	}
</style>
<template>
	<div class="student-knowledge-inventory">
		<tab-container
			model-key="skiTab"
			default-tab="about"
			:variant="tabVariant">
			<button data-tab="about">About</button>
			<button
				v-if="hasResults"
				data-tab="results">
				Results
			</button>
		</tab-container>
		<student-knowledge-inventory-about
			v-if="skiTab === 'about'"
			ref="skiTabPanel"
			data-panel="about">
		</student-knowledge-inventory-about>
		<student-knowledge-inventory-results
			v-if="skiTab === 'results'"
			:roster="currentRoster"
			ref="skiTabPanel"
			data-panel="results">
		</student-knowledge-inventory-results>
	</div>
</template>
